export default __webpack_public_path__ + "static/media/add.d62c01be.svg";